import React from "react"
import Register from "../components/pages/register"

const RegisterPage = (props) => <Register {...props} />

export default RegisterPage